import { css } from "@emotion/react";

import { dimensions } from "@styles";

export const footerBase = css`
  position: relative;
`;

export const fdaDisclaimer = css`
  @media (min-width: ${dimensions.desktop}) {
    max-width: 700px;
  }
`;

export const mobileLayout = css`
  text-align: center;
`;
